export const primaryColor = '#ff576d';
export const textGrayColor = '#747475';
export const whiteColor = '#ffffff';
export const textColor = '#262626';
export const secondaryColor = '#252d44';
export const lightBlue = '#4673D1';
